import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

// Images
import logoSm from "../../assets/images/logo-sm.png";
import logoDark from "../../assets/images/logo-dark.png";
import logoLight from "../../assets/images/logo-light.png";

// Redux Actions
import {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
} from "../../store/actions";

import ProfileMenu from "../../components/Common/TopbarDropdown/ProfileMenu";

const Header = ({ toggleLeftmenu, changeSidebarType }) => {
  // Toggle fullscreen
  const toggleFullscreen = () => {
    if (
      !document.fullscreenElement &&
      !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      const elem = document.documentElement;
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    }
  };

  // Toggle sidebar (mobile/desktop)
  const tToggle = () => {
    const body = document.body;
    if (window.innerWidth <= 998) {
      body.classList.toggle("sidebar-enable");
    } else {
      body.classList.toggle("vertical-collpsed");
      body.classList.toggle("sidebar-enable");
    }
  };

  return (
    <header id="page-topbar">
      <div className="navbar-header">
        {/* Left Section: Logo + Menu Button */}
        <div className="d-flex">
          <div className="navbar-brand-box text-center">
            {/* Dark Logo */}
            <Link to="/" className="logo logo-dark">
              <span className="logo-sm">
                <img src={logoSm} alt="logo-sm-dark" height="15" />
              </span>
              <span className="logo-lg">
                <img src={logoDark} alt="logo-dark" height="45" />
              </span>
            </Link>

            {/* Light Logo */}
            <Link to="/" className="logo logo-light">
              <span className="logo-sm">
                <img src={logoSm} alt="logo-sm-light" height="15" />
              </span>
              <span className="logo-lg">
                <img src={logoLight} alt="logo-light" height="45" />
              </span>
            </Link>
          </div>

          {/* Mobile Menu Toggle */}
          <button
            type="button"
            className="btn btn-sm px-3 font-size-24 header-item waves-effect"
            id="vertical-menu-btn"
            onClick={tToggle}
          >
            <i className="ri-menu-2-line align-middle"></i>
          </button>
        </div>

        {/* Right Section: Fullscreen + Profile */}
        <div className="d-flex">
          {/* Fullscreen Button */}
          <div className="dropdown d-none d-lg-inline-block ms-1">
            <button
              type="button"
              onClick={toggleFullscreen}
              className="btn header-item noti-icon"
              data-toggle="fullscreen"
            >
              <i className="ri-fullscreen-line"></i>
            </button>
          </div>

          {/* User Profile Dropdown */}
          <ProfileMenu />
        </div>
      </div>
    </header>
  );
};

// Map Redux state to props
const mapStatetoProps = (state) => {
  const { layoutType, showRightSidebar, leftMenu, leftSideBarType } =
    state.Layout;
  return { layoutType, showRightSidebar, leftMenu, leftSideBarType };
};

// Connect to Redux
export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
})(Header);